import TCampaignsAdd from './index.vue';

TCampaignsAdd.install = app => {
  app.component(TCampaignsAdd.name, TCampaignsAdd);
};

export default TCampaignsAdd;
